export const categories = [
  {
    id: 'canyin-meishi',
    name: '餐饮美食',
    slug: 'canyin-meishi',
    icon: 'ri-restaurant-line',
    description: '各类餐厅、小吃店、饮品店、烘焙坊等餐饮企业信息',
    count: 1256,
    imageSeq: 'cat-canyin',
  },
  {
    id: 'jianzhu-zhuangxiu',
    name: '建筑装修',
    slug: 'jianzhu-zhuangxiu',
    icon: 'ri-building-line',
    description: '建筑公司、装修公司、建材供应商、设计工作室等',
    count: 843,
    imageSeq: 'cat-jianzhu',
  },
  {
    id: 'jiaoyu-peixun',
    name: '教育培训',
    slug: 'jiaoyu-peixun',
    icon: 'ri-book-open-line',
    description: '各类培训机构、学校、幼儿园、在线教育平台等',
    count: 967,
    imageSeq: 'cat-jiaoyu',
  },
  {
    id: 'yiliao-jiankang',
    name: '医疗健康',
    slug: 'yiliao-jiankang',
    icon: 'ri-heart-pulse-line',
    description: '医院、诊所、药房、体检中心、康复机构等',
    count: 734,
    imageSeq: 'cat-yiliao',
  },
  {
    id: 'jiaju-shenghuo',
    name: '家居生活',
    slug: 'jiaju-shenghuo',
    icon: 'ri-home-4-line',
    description: '家具卖场、家居用品、家电销售、家政服务等',
    count: 1120,
    imageSeq: 'cat-jiaju',
  },
  {
    id: 'qiche-jiaotong',
    name: '汽车交通',
    slug: 'qiche-jiaotong',
    icon: 'ri-car-line',
    description: '汽车4S店、维修保养、驾校培训、租车服务等',
    count: 678,
    imageSeq: 'cat-qiche',
  },
  {
    id: 'luyou-jiudian',
    name: '旅游酒店',
    slug: 'luyou-jiudian',
    icon: 'ri-hotel-line',
    description: '旅行社、酒店民宿、景区景点、票务服务等',
    count: 892,
    imageSeq: 'cat-luyou',
  },
  {
    id: 'fuzhuang-shishang',
    name: '服装时尚',
    slug: 'fuzhuang-shishang',
    icon: 'ri-t-shirt-line',
    description: '服装品牌、鞋帽配饰、纺织面料、洗衣护理等',
    count: 1045,
    imageSeq: 'cat-fuzhuang',
  },
  {
    id: 'keji-hulianwang',
    name: '科技互联网',
    slug: 'keji-hulianwang',
    icon: 'ri-computer-line',
    description: '软件开发、网络服务、电子商务、IT外包等科技企业',
    count: 1567,
    imageSeq: 'cat-keji',
  },
  {
    id: 'falv-zixun',
    name: '法律咨询',
    slug: 'falv-zixun',
    icon: 'ri-scales-line',
    description: '律师事务所、法律咨询、知识产权代理、公证服务等',
    count: 432,
    imageSeq: 'cat-falv',
  },
  {
    id: 'jinrong-baoxian',
    name: '金融保险',
    slug: 'jinrong-baoxian',
    icon: 'ri-bank-line',
    description: '银行、保险公司、证券期货、投资理财、贷款服务等',
    count: 589,
    imageSeq: 'cat-jinrong',
  },
  {
    id: 'wuliukuaidi',
    name: '物流快递',
    slug: 'wuliukuaidi',
    icon: 'ri-truck-line',
    description: '物流公司、快递网点、仓储服务、货运代理等',
    count: 745,
    imageSeq: 'cat-wuliu',
  },
];